/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderMetadataInfo } from './ProviderMetadataInfo';
import {
    ProviderMetadataInfoFromJSON,
    ProviderMetadataInfoFromJSONTyped,
    ProviderMetadataInfoToJSON,
} from './ProviderMetadataInfo';

/**
 * 
 * @export
 * @interface OauthConnectRequest
 */
export interface OauthConnectRequest {
    /**
     * The Ampersand project ID or project name.
     * @type {string}
     * @memberof OauthConnectRequest
     */
    projectIdOrName: string;
    /**
     * The provider that this app connects to.
     * @type {string}
     * @memberof OauthConnectRequest
     */
    provider: string;
    /**
     * Your application's identifier for the organization or workspace that this connection belongs to (e.g. an org ID or team ID).
     * @type {string}
     * @memberof OauthConnectRequest
     */
    groupRef: string;
    /**
     * The display name for the group. Defaults to groupRef if not provided.
     * @type {string}
     * @memberof OauthConnectRequest
     */
    groupName?: string;
    /**
     * The ID that your app uses to identify the user whose SaaS credential will be used for this OAuth flow.
     * @type {string}
     * @memberof OauthConnectRequest
     */
    consumerRef: string;
    /**
     * The display name for the consumer. Defaults to consumerRef if not provided.
     * @type {string}
     * @memberof OauthConnectRequest
     */
    consumerName?: string;
    /**
     * The identifier for the provider workspace (e.g. the Salesforce subdomain).
     * @type {string}
     * @memberof OauthConnectRequest
     */
    providerWorkspaceRef?: string;
    /**
     * 
     * @type {{ [key: string]: ProviderMetadataInfo; }}
     * @memberof OauthConnectRequest
     */
    providerMetadata?: { [key: string]: ProviderMetadataInfo; };
    /**
     * ID of the provider app, returned from the [Create Provider App endpoint](https://docs.ampersand.ai/reference/provider-app/create-a-new-provider-app). If omitted, the default provider app that was set up on the Ampersand Dashboard is assumed.
     * @type {string}
     * @memberof OauthConnectRequest
     */
    providerAppId?: string;
    /**
     * This boolean flag is used by the UI library internally. Set it to false or omit it when manually calling this API.
     * @type {boolean}
     * @memberof OauthConnectRequest
     */
    enableCSRFProtection?: boolean;
}

/**
 * Check if a given object implements the OauthConnectRequest interface.
 */
export function instanceOfOauthConnectRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectIdOrName" in value;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "groupRef" in value;
    isInstance = isInstance && "consumerRef" in value;

    return isInstance;
}

export function OauthConnectRequestFromJSON(json: any): OauthConnectRequest {
    return OauthConnectRequestFromJSONTyped(json, false);
}

export function OauthConnectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OauthConnectRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectIdOrName': json['projectIdOrName'],
        'provider': json['provider'],
        'groupRef': json['groupRef'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'consumerRef': json['consumerRef'],
        'consumerName': !exists(json, 'consumerName') ? undefined : json['consumerName'],
        'providerWorkspaceRef': !exists(json, 'providerWorkspaceRef') ? undefined : json['providerWorkspaceRef'],
        'providerMetadata': !exists(json, 'providerMetadata') ? undefined : (mapValues(json['providerMetadata'], ProviderMetadataInfoFromJSON)),
        'providerAppId': !exists(json, 'providerAppId') ? undefined : json['providerAppId'],
        'enableCSRFProtection': !exists(json, 'enableCSRFProtection') ? undefined : json['enableCSRFProtection'],
    };
}

export function OauthConnectRequestToJSON(value?: OauthConnectRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectIdOrName': value.projectIdOrName,
        'provider': value.provider,
        'groupRef': value.groupRef,
        'groupName': value.groupName,
        'consumerRef': value.consumerRef,
        'consumerName': value.consumerName,
        'providerWorkspaceRef': value.providerWorkspaceRef,
        'providerMetadata': value.providerMetadata === undefined ? undefined : (mapValues(value.providerMetadata, ProviderMetadataInfoToJSON)),
        'providerAppId': value.providerAppId,
        'enableCSRFProtection': value.enableCSRFProtection,
    };
}

